var _excluded = ["onChange", "value", "placeholder", "className", "options", "displaySelectValue", "container", "allowClear"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { useMemo, useState } from 'react';
import { SelectContent, SelectItem, SelectTrigger, Select as SelectUI, SelectValue } from "./select";
export var Select = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _valueMap$value;
  var onChange = _ref.onChange,
    value = _ref.value,
    placeholder = _ref.placeholder,
    className = _ref.className,
    options = _ref.options,
    displaySelectValue = _ref.displaySelectValue,
    container = _ref.container,
    allowClear = _ref.allowClear,
    other = _objectWithoutProperties(_ref, _excluded);
  var valueMap = useMemo(function () {
    return options.reduce(function (acc, option) {
      acc[option.value] = option;
      return acc;
    }, {});
  }, [options]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(SelectUI, _extends({
    onValueChange: onChange,
    key: value,
    defaultValue: value,
    value: value,
    open: open,
    onOpenChange: setOpen
  }, other), /*#__PURE__*/React.createElement(SelectTrigger, {
    className: className,
    ref: ref,
    id: 'trigger',
    allowClear: allowClear,
    value: value,
    onClear: function onClear() {
      return onChange === null || onChange === void 0 ? void 0 : onChange('');
    },
    onArrowClick: function onArrowClick() {
      return setOpen(function (prev) {
        return !prev;
      });
    }
  }, /*#__PURE__*/React.createElement(SelectValue, {
    placeholder: placeholder
  }, value ? displaySelectValue ? displaySelectValue(value) : (_valueMap$value = valueMap[value]) === null || _valueMap$value === void 0 ? void 0 : _valueMap$value.label : null)), /*#__PURE__*/React.createElement(SelectContent, {
    container: container
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(SelectItem, {
      key: option.value,
      value: option.value
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-md text-gray-900 dark:text-[#FFF] cursor-pointer"
    }, option.label), option.description ? /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-gray-500 dark:text-foreground"
    }, option.description) : null);
  })));
});
Select.displayName = 'Select';